<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <span class="headline" style="font-size:1.3rem!important">{{showTitle}}</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-card-text style="padding: 30px 50px 0;">
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Available Amount: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <b>${{availableAmt | thousandSeprator}}</b>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Billed to Client: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="masterData.invoiceSent"
                placeholder=""
                prefix="$"
                hide-details
                disabled
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Yet to Invoice: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="masterData.invoicePending"
                placeholder=""
                prefix="$"
                hide-details
                disabled
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-divider></v-divider>
          <div v-for="(item, index) in quoteData" :key="index">
            <v-row>
              <v-col class="pb-0" cols="12" md="5" sm="12">
                <p class="title-1 form-label">Amount: </p>
              </v-col>
              <v-col class="pb-0" cols="12" md="7" sm="12">
                <v-text-field
                  type="number"
                  v-model="item.quoteAmt"
                  :disabled="item.status === quoteStatuses.ACCEPT"
                  hide-details
                  placeholder=""
                  prefix="$"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col class="pb-0" cols="12" md="5" sm="12">
                <p class="title-1 form-label">Start Month : </p>
              </v-col>
              <v-col class="pb-0" cols="12" md="7" sm="12">
                <v-menu
                  v-model="item.startCal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="input-field"
                      v-model="item.startMonth"
                      :disabled="item.status === quoteStatuses.ACCEPT && !item.editMode"
                      hide-details
                      append-icon="event"
                      dense
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    :min="minDate"
                    v-model="item.startMonth"
                    @input="item.startCal = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0" cols="12" md="5" sm="12">
                <p class="title-1 form-label">End Month : </p>
              </v-col>
              <v-col class="pb-0" cols="12" md="7" sm="12">
                <v-menu
                  v-model="item.endCal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="input-field"
                      v-model="item.endMonth"
                      :disabled="item.status === quoteStatuses.ACCEPT && !item.editMode"
                      hide-details
                      append-icon="event"
                      dense
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    :min="minDate"
                    v-model="item.endMonth"
                    @input="item.endCal = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0" cols="12" md="5" sm="12">
                <p class="title-1 form-label">Remarks: </p>
              </v-col>
              <v-col class="pb-0" cols="12" md="7" sm="12">
                <v-textarea
                  v-model="item.remarks"
                  :disabled="item.status === quoteStatuses.ACCEPT && !item.editMode"
                  placeholder=""
                  outlined
                  dense
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="mt-5" style="justify-content: right;" v-if="!item.editMode">
              <v-btn
                text
                color="warning"
                @click="changeEditStatus(index, true)"
                v-if="item.status === quoteStatuses.ACCEPT"
              >
                <v-icon left>mdi-pencil</v-icon>  Edit
              </v-btn>
              <v-btn
                text
                color="error"
                @click="removeQuoteData(index)"
                :disabled="item.status === quoteStatuses.ACCEPT"
              >
                <v-icon left>mdi-delete-forever</v-icon>  Delete
              </v-btn>
            </v-row>
            <v-row class="mt-5" style="justify-content: right;" v-if="item.editMode">
              <v-btn
                text
                color="error"
                @click="changeEditStatus(index, false)"
              >
                <v-icon left>mdi-close-circle</v-icon>  Cancel
              </v-btn>
              <v-btn
                text
                color="green"
                @click="saveMasterData(true)"
                v-if="item.status === quoteStatuses.ACCEPT"
              >
                <v-icon left>mdi-upload</v-icon>  Update
              </v-btn>
            </v-row>
            <v-divider></v-divider>
          </div>
          <div>
            <v-btn
              class="btn-invoice-sent-edit ml-0"
              color="warning"
              small
              @click="addQuoteData"
            >
              <v-icon color="white" title="Add Invoice Sent" small>mdi-plus</v-icon> Add
            </v-btn>
          </div>

          <!-- <div v-for="(item, index) in activityData" :key="index">
            <v-expansion-panels class="mb-2" v-model="item.panel" multiple accordion focusable>
              <v-expansion-panel expand>
                <v-expansion-panel-header>
                  <v-toolbar-title>
                    ${{item.amount | thousandSeprator}}
                  </v-toolbar-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                   <v-row class="mt-2">
                      <v-col class="pb-0" cols="12" md="5" sm="12">
                        <p class="title-1 form-label">Start Month : </p>
                      </v-col>
                      <v-col class="pb-0" cols="12" md="7" sm="12">
                        <v-menu
                          v-model="item.startCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="input-field"
                              v-model="item.startMonth"
                              append-icon="event"
                              readonly
                              dense
                              outlined
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            type="month"
                            v-model="item.startMonth"
                            @input="item.startCal = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0" cols="12" md="5" sm="12">
                        <p class="title-1 form-label">End Month : </p>
                      </v-col>
                      <v-col class="pb-0" cols="12" md="7" sm="12">
                        <v-menu
                          v-model="item.endCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="input-field"
                              v-model="item.endMonth"
                              append-icon="event"
                              readonly
                              dense
                              outlined
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            type="month"
                            v-model="item.endMonth"
                            @input="item.endCal = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="saveMasterData(false)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import moment from 'moment'
import MasterListsConfig from './config'
import utils from '@/utils'
export default {
  name: 'SalesEditModal',
  components: {
    Loading
  },
  mixins: [validationMixin],
  validations: function() {
    return this.rules
  },
  props: [
    'value',
    'editData'
  ],
  data() {
    return {
      masterData: {
        startMonth: 0,
        endMonth: 0
      },
      quoteStatuses: MasterListsConfig.quoteStatuses,
      quoteData: [],
      activityData: [],
      minDate: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      masterLists: state => state.campaign.masterLists,
      savedMasterList: state => state.campaign.savedMasterList
    }),
    currentYear() {
      return moment().format('YYYY')
    },
    nextYear() {
      return moment().add(1, 'years').format('YYYY')
    },
    disableMasterLists() {
      return this.$v.masterData.$invalid
    },
    availableAmt() {
      if (!this.editData) return 0
      let amt = 0
      let enteredAmts = 0
      if (this.editData.invoiceCreated) {
        amt += Number(this.editData.invoiceCreated)
      }
      // linked IOs
      if (this.editData.linkedIOs) {
        let matchMasterlist = this.masterLists.find(m => this.editData.linkedIOs.includes(m.quoteNo.replace('IO-', '')))
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0)
        }
      }
      // entered amounts
      if (this.editData.quoteData) {
        if (Array.isArray(this.editData.quoteData)) {
          this.editData.quoteData.map(quote => {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0)) {
              enteredAmts += Number(quote.quoteAmt)
            }
          })
        }
      }
      if (amt > 0) {
        return Number(amt) - Number(enteredAmts)
      }
      return 0
    },
    currentAvailableAmt() {
      if (!this.editData) return 0
      let amt = 0
      let enteredAmts = 0
      if (this.editData.invoiceCreated) {
        amt += Number(this.editData.invoiceCreated)
      }
      // linked IOs
      if (this.editData.linkedIOs) {
        let matchMasterlist = this.masterLists.find(m => this.editData.linkedIOs.includes(m.quoteNo.replace('IO-', '')))
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0)
        }
      }
      // entered amounts
      if (this.quoteData) {
        if (Array.isArray(this.quoteData)) {
          this.quoteData.map(quote => {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0)) {
              enteredAmts += Number(quote.quoteAmt)
            }
          })
        }
      }
      if (amt > 0) {
        return Number(amt) - Number(enteredAmts)
      }
      return 0
    },
    showTitle() {
      let titleTxt = ''
      if (this.editData) {
        if (this.editData.billingContact) {
          titleTxt += this.editData.billingContact.Name
        }
        titleTxt += ` (${this.editData.quoteNo})`
      }
      return titleTxt
    },
    rules() {
      const validationRules = {
        masterData: {
          startMonth: {
            required
          },
          endMonth: {
            required
          }
        }
      }
      return validationRules
    },
    startMonthErrors() {
      const errors = [];
      if (!this.$v.masterData.startMonth.$dirty) return errors;
      !this.$v.masterData.startMonth.required && errors.push('This field is required.');
      return errors;
    },
    endMonthErrors() {
      const errors = [];
      if (!this.$v.masterData.endMonth.$dirty) return errors;
      !this.$v.masterData.endMonth.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    editData: async function (newValue) {
      if (!newValue) {
        delete this.masterData.id
        this.resetQuoteData()
        return
      }
      this.masterData.id = newValue.id
      this.masterData.quoteAmt = newValue.quoteAmt
      this.masterData.activity = newValue.activity || []
      this.masterData.invoiceSent = newValue.invoiceSent || 0
      this.masterData.invoicePending = newValue.invoicePending || 0
      this.masterData.invoiceCreated = newValue.invoiceCreated || 0
      // this.masterData.startMonth = newValue.startMonth
      // this.masterData.endMonth = newValue.endMonth
      this.quoteData = []
      if (newValue.quoteData) {
        this.quoteData = utils.func.refreshJSON(newValue.quoteData)
        this.quoteData = this.quoteData.map(q => {
          q.editMode = false
          return q
        })
      }
    }
  },
  async mounted() {
  },
  methods: {
    addQuoteData() {
      this.quoteData.push({
        quoteAmt: 0,
        startMonth: '',
        endMonth: '',
        status: 0,
        new: true
      })
    },
    removeQuoteData(index) {
      this.quoteData.splice(index, 1)
    },
    async saveMasterData(isUpdate = false) {
      // check if entered amt larger
      if (this.currentAvailableAmt < 0) {
        this.$swal({
          text: 'Available Amount Not Enough.',
          type: 'error'
        });
        return false
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let sendFinanceEmail = false
          let isUpdateEmail = false
          let quote = Object.assign([], this.quoteData)
          quote = quote.map(a => {
            delete a.startCal
            delete a.endCal
            if (a.editMode && isUpdate) {
              isUpdateEmail = true
              a.status = 0
            }
            if (a.new) sendFinanceEmail = true
            delete a.editMode
            delete a.new
            return a
          })
          quote = quote.filter(q => q.quoteAmt && q.startMonth && q.endMonth)
          if (!quote.length) {
            this.$swal({
              text: 'Invalid Quote Data.',
              type: 'error'
            });
            this.isLoading = false
            return
          }
          let masterData = Object.assign({}, {
            id: this.editData.id,
            quoteData: quote,
            sendFinanceEmail,
            isUpdateEmail
          })
          let saveData = []
          saveData.push(masterData)
          // // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: 'Error Saving Data.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully saved.',
            type: 'success'
          });
          this.$emit('created')
          if (!isUpdate) {
            // if not for updating, reset data and close the dialog
            this.resetMasterData()
            this.close()
          }
        }
      })
    },
    resetMasterData() {
      this.masterData = {
        startMonth: 0,
        endMonth: 0
      }
    },
    close() {
      this.$emit('input');
    },
    changeEditStatus(index, status) {
      this.quoteData[index].editMode = status
      this.quoteData = Object.assign([], this.quoteData)
    }
  }
}
</script>
<style scoped>
  .custom-danger {
    color: #ff5252 !important;
    font-size: 12px;
  }
  .form-label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: bold;
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// SalesEditModal.vue?46f9474c